import { HttpClient } from '@angular/common/http';
import { PatientsService } from 'src/app/patients.service';
import { Component, OnInit,Output,EventEmitter,ViewChild,ElementRef,ChangeDetectorRef } from '@angular/core';
import { GastroFormsService } from '../gastro-forms.service';
import { LoginService } from 'src/app/login.service';
import { AutotextService } from '../autotext.service';
import { fromEvent,Subject, Subscription} from 'rxjs';
import { map, tap, switchMap, takeUntil, finalize,debounceTime,distinctUntilChanged} from 'rxjs/operators';


@Component({
    selector: 'app-consent-form',
    templateUrl: './consent-form.component.html',
    styleUrls: ['./consent-form.component.scss'],
    standalone: false
})
export class ConsentFormComponent implements OnInit {
  private sub:Subscription

  constructor(private changeDetector : ChangeDetectorRef,public gfs:GastroFormsService, private ls:LoginService,public atS:AutotextService,public pat:PatientsService,private http: HttpClient) { }
  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();
  @ViewChild("canvaspatSign", { static: false })
 
  canvaspatSign: ElementRef<HTMLCanvasElement>;
  @ViewChild("canvaguardianSign", { static: false })
  canvaguardianSign: ElementRef<HTMLCanvasElement>;
  ctx: CanvasRenderingContext2D;
  changepatCanvas$ = new Subject();
  changeguardianCanvas$= new Subject()
  destroy$ = new Subject();
  examsPerformed=""
  @ViewChild("canvasDocSign", { static: true })
  canvasDocSign: ElementRef<HTMLCanvasElement>;
  changeDocCanvas$= new Subject()
  showPrint=false
  private gastroscopySub: Subscription;
  private colonoscopySub: Subscription;
  private sigmoidoscopySub: Subscription;
  private sedationConsentSub: Subscription;

  ngOnInit(): void {
    this.ls.loginMissing();
    this.gastroscopySub = this.gfs.Form.get('Gastroscopy').valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((data) => {
      this.examsPerformed=this.getExamPerformedString()
      console.log(this.gfs.Form.get('Guardian').value)
    })
    this.colonoscopySub =this.gfs.Form.get('Colonoscopy').valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((data) => {
      this.examsPerformed=this.getExamPerformedString()
    })
    this.sigmoidoscopySub =this.gfs.Form.get('Sigmoidoscopy').valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((data) => {
      this.examsPerformed=this.getExamPerformedString()
    })
    this.sedationConsentSub = this.gfs.Form.get('SedationConsent').valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((data) => {
      if(this.gfs.Form.get('SedationConsent').value==true)
      this.gfs.Form.get('EndoscopyConsent').setValue(true)
    })

    this.sub=this.gfs.formLoaded$.subscribe(()=>{
      
      if (this.gfs.Form && this.gfs.Form.get('AutoIndex').value) {
        this.showPrint=true
      }

      if (this.gfs.Form && this.gfs.Form.get('patSign').value && (this.gfs.Form.get('Guardian').value!==true && this.gfs.Form.get('Guardian').value!=1)) {
        this.loadSign();
      }
      if (this.gfs.Form && this.gfs.Form.get('guardianSign').value && (this.gfs.Form.get('Guardian').value===true || this.gfs.Form.get('Guardian').value==1)) {
        this.loadGuardianSign();
      }
      if (this.gfs.Form && this.gfs.Form.get('docSign').value) {
        this.loadDocSign();
      }


      this.examsPerformed=this.getExamPerformedString()

      if(this.gfs.Form && !this.gfs.Form.get("CreationTime").value){
        this.gfs.Form.get("CreationTime").setValue(new Date(), { emitEvent: false })
      }
      if(this.gfs.Form && !this.gfs.Form.get('AdmissionTime').value){
        const formattedTime = this.formatTime(this.gfs.Form.get("CreationTime").value);
        this.gfs.Form.get("AdmissionTime").setValue(formattedTime,{emitEvent:false})

      }

      if(this.pat.currentPatient.UID==this.ls.UID && !this.gfs.Form.get('doctor').value){
        this.gfs.Form.get('doctor').setValue(this.ls.getUserName())
      }
      if(this.pat.currentPatient.UID==this.ls.UID && !this.gfs.Form.get('docLicense').value){
        this.gfs.Form.get('docLicense').setValue(this.ls.license)
      }
      
    })
  }

  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }
 
  printForm(){
    this.print.emit('1')
  }

  ngOnDestroy(): void {
    if(this.sub)
    this.sub.unsubscribe()
    this.destroy$.next(undefined);
    this.gastroscopySub.unsubscribe();
    this.colonoscopySub.unsubscribe();
    this.sigmoidoscopySub.unsubscribe();
    this.sedationConsentSub.unsubscribe();
 
}

ngAfterViewInit(){
  this.changeDetector.detectChanges();
  this.sub = this.changepatCanvas$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: any) => {
      // decleration
      const handleEnd=(evt)=> {
        evt.preventDefault();
        const touches = evt.changedTouches;
        for (let i = 0; i < touches.length; i++) {
          // const color = "black";
          var ctx =evt.target.getContext('2d')
          let idx = ongoingTouchIndexById(touches[i].identifier);
          if (idx >= 0) {
            ctx.lineWidth = "10px";
            ctx.fillStyle = "black";
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        this.savePatSign()

      }
      this.ctx = data.ctx;
      this.canvaspatSign.nativeElement.addEventListener('touchstart', handleStart);
      this.canvaspatSign.nativeElement.addEventListener('touchend', handleEnd);
      this.canvaspatSign.nativeElement.addEventListener('touchcancel', handleCancel);
      this.canvaspatSign.nativeElement.addEventListener('touchmove', handleMove);
      const ongoingTouches = [];
      let offsetX
      let offsetY
      function handleStart(evt) {
        evt.preventDefault();
        const touches = evt.changedTouches;
         offsetX = evt.target.getBoundingClientRect().left;
         offsetY = evt.target.getBoundingClientRect().top;
        console.log(offsetX, offsetY)
        for (let i = 0; i < touches.length; i++) {
          ongoingTouches.push(copyTouch(touches[i]));
        }
      }
        function handleMove(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
  
            const idx = ongoingTouchIndexById(touches[i].identifier);
            if (idx >= 0) {
              var ctx =evt.target.getContext('2d')
              // console.log(ctx);
  
              ctx.beginPath();
              ctx.moveTo(ongoingTouches[idx].clientX - offsetX, ongoingTouches[idx].clientY - offsetY);
              ctx.lineTo(touches[i].clientX - offsetX, touches[i].clientY - offsetY);
              ctx.lineWidth = "10px";
              ctx.strokeStyle = "black";
              ctx.lineJoin = "round";
              ctx.closePath();
              ctx.stroke();
              ongoingTouches.splice(idx, 1, copyTouch(touches[i]));  // swap in the new touch record
            }
          }
        }
  
      
  
        function handleCancel(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
            let idx = ongoingTouchIndexById(touches[i].identifier);
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        
      function copyTouch({ identifier, clientX, clientY }) {
        return { identifier, clientX, clientY };
      }
      function ongoingTouchIndexById(idToFind) {
        for (let i = 0; i < ongoingTouches.length; i++) {
          const id = ongoingTouches[i].identifier;
          if (id === idToFind) {
            return i;
          }
        }
        return -1;    // not found
      }

      
    ;})
    this.sub = this.changeguardianCanvas$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: any) => {
      this.ctx = data.ctx;
      const handleEnd=(evt)=> {
        evt.preventDefault();
        const touches = evt.changedTouches;
        for (let i = 0; i < touches.length; i++) {
          // const color = "black";
          var ctx =evt.target.getContext('2d')
          let idx = ongoingTouchIndexById(touches[i].identifier);
          if (idx >= 0) {
            ctx.lineWidth = "10px";
            ctx.fillStyle = "black";
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        this.saveGuardianSign()

      }
      this.ctx = data.ctx;
      this.canvaguardianSign.nativeElement.addEventListener('touchstart', handleStart);
      this.canvaguardianSign.nativeElement.addEventListener('touchend', handleEnd);
      this.canvaguardianSign.nativeElement.addEventListener('touchcancel', handleCancel);
      this.canvaguardianSign.nativeElement.addEventListener('touchmove', handleMove);
      const ongoingTouches = [];
      let offsetX
      let offsetY
      function handleStart(evt) {
        evt.preventDefault();
        const touches = evt.changedTouches;
         offsetX = evt.target.getBoundingClientRect().left;
         offsetY = evt.target.getBoundingClientRect().top;
        console.log(offsetX, offsetY)
        for (let i = 0; i < touches.length; i++) {
          ongoingTouches.push(copyTouch(touches[i]));
        }
      }
        function handleMove(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
  
            const idx = ongoingTouchIndexById(touches[i].identifier);
            if (idx >= 0) {
              var ctx =evt.target.getContext('2d')
              // console.log(ctx);
  
              ctx.beginPath();
              ctx.moveTo(ongoingTouches[idx].clientX - offsetX, ongoingTouches[idx].clientY - offsetY);
              ctx.lineTo(touches[i].clientX - offsetX, touches[i].clientY - offsetY);
              ctx.lineWidth = "10px";
              ctx.strokeStyle = "black";
              ctx.lineJoin = "round";
              ctx.closePath();
              ctx.stroke();
              ongoingTouches.splice(idx, 1, copyTouch(touches[i]));  // swap in the new touch record
            }
          }
        }
  
      
  
        function handleCancel(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
            let idx = ongoingTouchIndexById(touches[i].identifier);
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        
      function copyTouch({ identifier, clientX, clientY }) {
        return { identifier, clientX, clientY };
      }
      function ongoingTouchIndexById(idToFind) {
        for (let i = 0; i < ongoingTouches.length; i++) {
          const id = ongoingTouches[i].identifier;
          if (id === idToFind) {
            return i;
          }
        }
        return -1;    // not found
      }

      
     
    });
    this.sub = this.changeDocCanvas$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: any) => {
      // decleration
      const handleEnd=(evt)=> {
        evt.preventDefault();
        const touches = evt.changedTouches;
        for (let i = 0; i < touches.length; i++) {
          // const color = "black";
          var ctx =evt.target.getContext('2d')
          let idx = ongoingTouchIndexById(touches[i].identifier);
          if (idx >= 0) {
            ctx.lineWidth = "10px";
            ctx.fillStyle = "black";
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        this.saveDocSign()

      }
      this.ctx = data.ctx;
      this.canvasDocSign.nativeElement.addEventListener('touchstart', handleStart);
      this.canvasDocSign.nativeElement.addEventListener('touchend', handleEnd);
      this.canvasDocSign.nativeElement.addEventListener('touchcancel', handleCancel);
      this.canvasDocSign.nativeElement.addEventListener('touchmove', handleMove);
      const ongoingTouches = [];
      let offsetX
      let offsetY
      function handleStart(evt) {
        evt.preventDefault();
        const touches = evt.changedTouches;
         offsetX = evt.target.getBoundingClientRect().left;
         offsetY = evt.target.getBoundingClientRect().top;
        console.log(offsetX, offsetY)
        for (let i = 0; i < touches.length; i++) {
          ongoingTouches.push(copyTouch(touches[i]));
        }
      }
        function handleMove(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
  
            const idx = ongoingTouchIndexById(touches[i].identifier);
            if (idx >= 0) {
              var ctx =evt.target.getContext('2d')
              // console.log(ctx);
  
              ctx.beginPath();
              ctx.moveTo(ongoingTouches[idx].clientX - offsetX, ongoingTouches[idx].clientY - offsetY);
              ctx.lineTo(touches[i].clientX - offsetX, touches[i].clientY - offsetY);
              ctx.lineWidth = "10px";
              ctx.strokeStyle = "black";
              ctx.lineJoin = "round";
              ctx.closePath();
              ctx.stroke();
              ongoingTouches.splice(idx, 1, copyTouch(touches[i]));  // swap in the new touch record
            }
          }
        }
  
      
  
        function handleCancel(evt) {
          evt.preventDefault();
          const touches = evt.changedTouches;
          for (let i = 0; i < touches.length; i++) {
            let idx = ongoingTouchIndexById(touches[i].identifier);
            ongoingTouches.splice(idx, 1);  // remove it; we're done
          }
        }
        
      function copyTouch({ identifier, clientX, clientY }) {
        return { identifier, clientX, clientY };
      }
      function ongoingTouchIndexById(idToFind) {
        for (let i = 0; i < ongoingTouches.length; i++) {
          const id = ongoingTouches[i].identifier;
          if (id === idToFind) {
            return i;
          }
        }
        return -1;    // not found
      }

      
    ;})
}

getExamPerformedString() {
  const examsPerformed = [];
  
  if (this.gfs.Form.get("Gastroscopy").value === true || this.gfs.Form.get("Gastroscopy").value == 1) {
    examsPerformed.push("גסטרוסקופיה");
  }

  if (this.gfs.Form.get("Colonoscopy").value === true || this.gfs.Form.get("Colonoscopy").value == 1) {
    examsPerformed.push("קולונוסקפיה");
  }

  if (this.gfs.Form.get("Sigmoidoscopy").value === true || this.gfs.Form.get("Sigmoidoscopy").value == 1) {
    examsPerformed.push("סיגמאידוסקופיה");
  }

  return examsPerformed.join(', ');
}

 
clearSign() {
  var ctx = this.canvaspatSign.nativeElement.getContext("2d");
  ctx.clearRect(
    0,
    0,
    this.canvaspatSign.nativeElement.width,
    this.canvaspatSign.nativeElement.height
  );
  this.gfs.Form.get('patSign').setValue('');
}
 
setPatCanvas() {
  this.changeDetector.detectChanges();
  this.ctx = this.canvaspatSign.nativeElement.getContext("2d");
  this.changepatCanvas$.next({ canvas: this.canvaspatSign, ctx: this.ctx });
}
setguardianSignCanvas(){
  this.changeDetector.detectChanges();
  this.ctx = this.canvaguardianSign.nativeElement.getContext("2d");
  this.changeguardianCanvas$.next({ canvas: this.canvaguardianSign, ctx: this.ctx });
}

setDocCanvas(){
  this.changeDetector.detectChanges();
  this.ctx = this.canvasDocSign.nativeElement.getContext("2d");
  this.changeDocCanvas$.next({ canvas: this.canvasDocSign, ctx: this.ctx });
}
 
loadSign(){
  var ctx = this.canvaspatSign.nativeElement.getContext("2d");
    const imgPatSign = document.createElement("img");
    imgPatSign.onload = function () {
      ctx.drawImage(imgPatSign, 0, 0); // Or at whatever offset you like
    };
    imgPatSign.src = this.gfs.Form.get("patSign").value;
}
loadGuardianSign(){
  var ctx = this.canvaguardianSign.nativeElement.getContext("2d");
    const imgGuardianSign = document.createElement("img");
    imgGuardianSign.onload = function () {
      ctx.drawImage(imgGuardianSign, 0, 0); // Or at whatever offset you like
    };
    imgGuardianSign.src = this.gfs.Form.get("guardianSign").value;
}
loadDocSign(){
  var ctx = this.canvasDocSign.nativeElement.getContext("2d");
  const imgPatSign = document.createElement("img");
  imgPatSign.onload = function () {
    ctx.drawImage(imgPatSign, 0, 0); // Or at whatever offset you like
  };
  imgPatSign.src = this.gfs.Form.get("docSign").value;
}
 
savePatSign() {
  let canvasUrl = this.canvaspatSign.nativeElement.toDataURL("image/png");
      this.gfs.Form.get("patSign").setValue(canvasUrl);
 
  }
  saveGuardianSign() {
    let canvasUrl = this.canvaguardianSign.nativeElement.toDataURL("image/png");
        this.gfs.Form.get("guardianSign").setValue(canvasUrl);
 
    }
    saveDocSign(){
      let canvasUrl = this.canvasDocSign.nativeElement.toDataURL("image/png");
        this.gfs.Form.get("docSign").setValue(canvasUrl);
 
    }
 
  clearguardianSignSign(){
    var ctx = this.canvaguardianSign.nativeElement.getContext("2d");
    ctx.clearRect(
      0,
      0,
      this.canvaguardianSign.nativeElement.width,
      this.canvaguardianSign.nativeElement.height
    );
    this.gfs.Form.get('guardianSign').setValue('');
  }

  clearDocSign(){
    var ctx = this.canvasDocSign.nativeElement.getContext("2d");
    ctx.clearRect(
      0,
      0,
      this.canvasDocSign.nativeElement.width,
      this.canvasDocSign.nativeElement.height
    );
    this.gfs.Form.get('docSign').setValue('');
  }



  saveForm(){
    if(this.gfs.Form.get('AutoIndex').value){
      return 
    }
    this.gfs.saveConsentForm().subscribe((data)=>{
      console.log(data,'data')
   if (data.hasOwnProperty('AutoIndex')){
    this.gfs.Form.get('AutoIndex').setValue(data['AutoIndex'])
    this.gfs.FormIndex=data['AutoIndex']
   }
    })
  }

  saveAndClose(){
    if(this.gfs.Form.get('AutoIndex').value){
      return this.closed.emit(null)
    }
    this.gfs.saveConsentForm().subscribe((data)=>{
   if (data.hasOwnProperty('status')){
     data['status']=='ok'?  this.closed.emit(null): null
   }
    })
  }

  formatTime(date: Date): string {
    date=new Date(date)
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  printConsent(){
    window.open('api/printpdf/'+this.gfs.FormIndex+'/'+this.pat.currentPatient.PID+'/'+'he-IL'+'/'+ 'n' +'/'+  'n'+ '/'+ 'simple'+ '/'+ '2' + '/' + 'y' + '/' + 'n'+'/y');
  }
}
